// src/components/Header.jsx
import React, { useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { useAuth } from '../authContext'
import { DOKUMENTKLASSEN } from '../dokumentklassen'
import useIsDesktop from './shared/useIsDesktop'
import { useMobilAnsichtErzwingen } from './shared/useMobilAnsichtErzwingen'
import TippsTricksModal from './shared/TippsTricksModal'
import logo from '../assets/logo.png'

function Header ({ onLogout }) {
  const { hatRolle } = useAuth()
  const location = useLocation()
  const isDesktop = useIsDesktop()
  const [mobilAnsichtErzwingen, setMobilAnsichtErzwingen] =
    useMobilAnsichtErzwingen()
  const [tippsOffen, setTippsOffen] = useState(false)

  // Aus der Dokumentklassen-Registry abgeleitet, statt hart codiert - eine neue Dokumentklasse
  // taucht hier automatisch als Tab auf, sobald sie in dokumentklassen/index.js ergänzt wird.
  const publicTabs = DOKUMENTKLASSEN.map(({ pfad, titel }) => ({
    id: pfad.replace('/', ''),
    label: titel,
    path: pfad
  }))

  const adminTabs = [{ id: 'users', label: 'Benutzer', path: '/users' }]
  // Nur für die Rolle "System" (Betreiber-Account) - taucht für Kunden-Admins nicht auf,
  // auch wenn diese über adminTabs oben Zugriff auf "Benutzer" haben.
  const systemTabs = [{ id: 'system', label: 'System', path: '/system' }]

  const getActiveTab = () => {
    const path = location.pathname
    const publicTab = publicTabs.find(tab => path.startsWith(tab.path))
    if (publicTab) return publicTab.id
    const adminTab = adminTabs.find(tab => path.startsWith(tab.path))
    if (adminTab) return adminTab.id
    const systemTab = systemTabs.find(tab => path.startsWith(tab.path))
    if (systemTab) return systemTab.id
    return publicTabs[0]?.id ?? 'extraction'
  }

  const activeTab = getActiveTab()

  return (
    <div className='header'>
      <div className='header-left'>
        <div className='header-logo'>
          <img src={logo} alt='OWL Software' className='header-logo-image' />
        </div>
        <div className='tab-navigation'>
          {publicTabs.map(tab => (
            <NavLink
              key={tab.id}
              to={tab.path}
              className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
            >
              {tab.label}
            </NavLink>
          ))}
          {hatRolle('Admin') &&
            adminTabs.map(tab => (
              <NavLink
                key={tab.id}
                to={tab.path}
                className={`tab-button admin-only ${
                  activeTab === tab.id ? 'active' : ''
                }`}
              >
                {tab.label}
              </NavLink>
            ))}
          {hatRolle('System') &&
            systemTabs.map(tab => (
              <NavLink
                key={tab.id}
                to={tab.path}
                className={`tab-button admin-only ${
                  activeTab === tab.id ? 'active' : ''
                }`}
              >
                {tab.label}
              </NavLink>
            ))}
        </div>
      </div>
      <div className='header-right'>
        <button
          type='button'
          className='btn btn-tipps'
          onClick={() => setTippsOffen(true)}
        >
          Tipps &amp; Tricks
        </button>
        {isDesktop && (
          <label className='mobil-ansicht-toggle'>
            <input
              type='checkbox'
              checked={mobilAnsichtErzwingen}
              onChange={e => setMobilAnsichtErzwingen(e.target.checked)}
            />
            📱 Mobile Ansicht
          </label>
        )}
        <button type='button' className='btn-logout' onClick={onLogout}>
          Abmelden
        </button>
      </div>
      {tippsOffen && <TippsTricksModal onClose={() => setTippsOffen(false)} />}
    </div>
  )
}

export default Header
